export default "__VITE_ASSET__841a2a56__"